export default __webpack_public_path__ + "static/media/zelle.b2502c42.png";